import * as React from 'react'
import { useCallback, useState } from 'react'
import * as Modal from 'react-overlays/lib/Modal'
import styles from './invitation_modal.module.scss'
import { InvitationForm } from './invitation_form'
import { InvitationSharing } from './invitation_sharing'
import Invitation from 'entities/cooperation/invitation'
import { MdClose } from 'react-icons/md'
import classnames from 'classnames/bind'

const cx = classnames.bind(styles)

type Props = {
  show: boolean
  closeModal: () => void
}

const InvitationModal: React.FC<Props> = ({ show, closeModal }) => {
  const [createdInvitation, setCreatedInvitation] = useState<Invitation | null>(null)
  const onCompleteCallback = useCallback(invitation => setCreatedInvitation(invitation), [])
  const customCloseModal = useCallback(() => {
    setCreatedInvitation(null)
    closeModal()
  }, [closeModal])

  return (
    <Modal show={show}>
      <div className={styles.modal}>
        <div className={styles.modalInner}>
          <div className={styles.modalHeader}>
            <div className={styles.headerTitle}>{I18n.t('offers.pages.show.components.invitation_modal.title')}</div>
            <button type="button" className={cx(styles.button, styles.closeButton)} onClick={customCloseModal}>
              <MdClose size={24} />
            </button>
          </div>
          {createdInvitation ? (
            <InvitationSharing invitation={createdInvitation} />
          ) : (
            <InvitationForm onComplete={onCompleteCallback} />
          )}
        </div>
      </div>
    </Modal>
  )
}

export default InvitationModal
